import React from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { useParams } from 'umi';
import { FRAME_TYPE_MAP } from '@/pages/benchmark/_config/constant';

export default function MetricOtdrService(props: any) {
  const { style, className, config, children, data, ...resetProps } = props || {};
  const { api } = config || {};
  const { metric } = useParams<{ metric: string; }>();
  return (
    <div className={className} style={style}>
      {/* @ts-ignore */}
      <Service
        api={api}
        dataKey={"metricData"}
        trackData={['frameType']}
        data={data}
        filterLoading={false}
        beforeRequest={(data) => {
          const { frameType } = data;
          const params = {
            filters: {},
            frame_type: FRAME_TYPE_MAP[frameType],
            metrics: [metric]
          };
          return params;
        }}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            ...resetProps
          }))}
      </Service>
    </div>
  );
}
